import React from "react";
import PropTypes from "prop-types";
import { motion } from "motion/react";

const AnimatedSection = ({
  id,
  className = "",
  children,
  initial = { opacity: 0, y: 50 },
  whileInView = { opacity: 1, y: 0 },
  transition = { duration: 0.8 },
  viewport = { once: true },
}) => {
  return (
    <motion.section
      id={id}
      className={className}
      initial={initial}
      whileInView={whileInView}
      transition={transition}
      viewport={viewport}>
      {children}
    </motion.section>
  );
};

AnimatedSection.propTypes = {
  id: PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
  initial: PropTypes.object,
  whileInView: PropTypes.object,
  transition: PropTypes.object,
  viewport: PropTypes.object,
};

export default AnimatedSection;
